
new Vue({
    el:"#venues-app",
    data: {
        locationDropdown: false,
        categoryDropdown:false,
        capacityDropdown: false,
        facilityDropdown: false,
        locations: [],
        categories: [],
        capacities: [],
        facilities: [],
        keywords: '',
        locationFilters: [],
        categoryFilters: [],
        capacityFilters: [],
        facilityFilters: [],
        allLocations: true,
        allCategories: true,
        allCapacities: true,
        allFacilities: true,
        numberOfItemsShown: 9,
        venueItems: [],
        stickyFilters: Number,
        bottomOfList: Number,
        headerEl: null,
        filterBarTopPosition: 0
    },
    methods: {

        convertCapacityToNumber(y) {
            var pattern = "(.*)-";
      
            var result = y.match(pattern);
            if (result == null) {
                result = y.replace("+", "");
            }
            if (result != null){
                result.replace("-", "");

           
            }

            //console.log("****",parseInt(result));
            return parseInt(result);
        },
        hoverOutTimeout: function() {
            var self = this;
            
            setTimeout(() => {
                self.locationDropdown = false;
                self.categoryDropdown = false;
                self.capacityDropdown = false;
                self.facilityDropdown = false;
            }, 1000);
        },
        showMore(){
            this.numberOfItemsShown += 9;
        },
        getScrollTop() {
            if (typeof pageYOffset !== 'undefined') {
                //most browsers except IE before #9
                return pageYOffset;
            } else {
                var B= document.body; //IE 'quirks'
                var D= document.documentElement; //IE with doccategory
                D= (D.clientHeight)? D: B;
                return D.scrollTop;
            }
        },
        handleScroll() {
            var self = this;
            if (window.requestAnimationFrame) {
                window.requestAnimationFrame(self.updateFilterBarStickiness);
            } else {
                self.updateFilterBarStickiness();
            }
        },
        handleClick(e) {
            var self = this;
            if (!e.target.classList.contains("js-dropdown-area")){
                self.locationDropdown = false;
                self.categoryDropdown = false;
                self.capacityDropdown = false;
                self.facilityDropdown = false;
            }
        },
        getElementTop(elem) {
            var box = elem.getBoundingClientRect();

            var body = document.body;
            var docEl = document.documentElement;

            var scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
            var clientTop = docEl.clientTop || body.clientTop || 0;
            var top = box.top + scrollTop - clientTop;

            return Math.round(top);
        },
        updateFilterBarStickiness() {
            var self = this;

            if (!self.$refs.filterList.isScrolled) {
                self.filterBarTopPosition = self.getElementTop(self.$refs.filterList);
            }

            var headerHeight = self.headerEl.offsetHeight;
            var bottomPositionOfList = (self.getElementTop(self.$refs.venuesList) - headerHeight) + self.$refs.venuesList.offsetHeight - self.$refs.filterList.offsetHeight;

            if (self.getScrollTop() > (self.filterBarTopPosition - headerHeight)) {
                self.$refs.filterList.classList.add('o-filter-list--scrolled');
                self.$refs.filterList.style.willChange = "";
                self.$refs.filterList.isScrolled = true;

                if (self.getScrollTop() > bottomPositionOfList) {
                    self.$refs.filterList.classList.add('o-filter-list--hidden');
                } else {
                    self.$refs.filterList.classList.remove('o-filter-list--hidden');
                }
            } else {
                self.$refs.filterList.classList.remove('o-filter-list--scrolled');
                self.$refs.filterList.classList.remove('o-filter-list--hidden');
                self.$refs.filterList.style.willChange = "background";
                self.$refs.filterList.isScrolled = false;
            }

            if (self.getScrollTop() < self.bottomOfList) {
                self.$refs.filterList.classList.remove('o-filter-list--hidden');
            }

        }
    },
    computed :{
        filteredVenueItems(){
            var self = this;
            var filteredVenueItems = self.venueItems;

            if (self.locationFilters.length > 0) {
                filteredVenueItems = filteredVenueItems.filter(venueItem => self.locationFilters.indexOf(venueItem.location) !== -1);
            }

            if (self.categoryFilters.length > 0) {
                filteredVenueItems = filteredVenueItems.filter(venueItem => {
                    for (var i = 0; i < venueItem.categories.length; i++) {
                        var category = venueItem.categories[i];
                        if (self.categoryFilters.indexOf(category) !== -1) {
                            return true;
                        }
                    }
                    return false;
                });
            }

            if (self.capacityFilters.length > 0){
                filteredVenueItems = filteredVenueItems.filter(venueItem => self.capacityFilters.indexOf(venueItem.capacity) !== -1);
                var multipleItems = [];
                self.capacityFilters.forEach(x => {
                    self.venueItems.forEach(venueItem => {
                        venueItem.capacity.forEach(y => {
                            if (x == y) {
                                multipleItems.push(venueItem);
                            }
                        })
                    })
                 
                })

                filteredVenueItems = multipleItems;
            }

            if (self.facilityFilters.length > 0) {
                filteredVenueItems = filteredVenueItems.filter(venueItem => {
                    for (var i = 0; i < venueItem.facilities.length; i++) {
                        var facility = venueItem.facilities[i];
                        if (self.facilityFilters.indexOf(facility) !== -1) {
                            return true;
                        }
                    }
                    return false;
                });
            }

            if (self.keywords.trim()) {

                const ignoredWords = ['the', 'be', 'to', 'of', 'and', 'a', 'in', 'i', 'it', 'for', 'on', 'with', 'as', 'at', 'by', 'from', 'an'];
                const keywords = self.keywords.toLowerCase().trim().split(/\s+/).filter(keyword => !ignoredWords.includes(keyword));

                const keywordMatches = filteredVenueItems.map(venueItem => {
                    let score = 0;
                    keywords.forEach((keyword, i) => {
                        let text = venueItem.keywords;
                        let index = 0;
                        while ((index = text.indexOf(keyword)) !== -1) {
                            score += Math.max((10000 - index) * (keywords.length - i), 10);
                            text = text.substr(index + 1);
                        }
                    });
                    return { venueItem: venueItem, score: score };
                });

                filteredVenueItems = keywordMatches
                    .filter(m => m.score)
                    .sort((a, b) => b.score - a.score)
                    .map(m => m.venueItem);

            }

            if (filteredVenueItems.length > self.numberOfItemsShown) {
                filteredVenueItems = filteredVenueItems.slice(0, self.numberOfItemsShown);
            } 

            return filteredVenueItems;
        }
    },
    watch: {
        filteredVenueItems(val){
            var self = this;
            self.$nextTick(() => {
                self.bottomOfList = self.$refs.filterList.offsetHeight + self.$refs.venuesList.offsetHeight - 200;
            })
        },
        allLocations(val){
            if (val) {
                this.locationFilters = [];
            }
        },
        allCategories(val) {
            if (val) {
                this.categoryFilters = [];
            }
        },
        allCapacities(val){
            if (val) {
                this.capacityFilters = [];
            }
        },
        allFacilities(val) {
            if (val) {
                this.facilityFilters = [];
            }
        },
        locationFilters(){
            if (this.locationFilters.length > 0){
                this.allLocations = false;
            } else {
                this.allLocations = true;
            }
        },
        categoryFilters(){
            if (this.categoryFilters.length > 0) {
                this.allCategories = false;
            } else {
                this.allCategories = true;
            }
        },
        capacityFilters() {
            if (this.capacityFilters.length > 0) {
                this.allCapacities = false;
            } else {
                this.allCapacities = true;
            }
        },
        facilityFilters() {
            if (this.facilityFilters.length > 0) {
                this.allFacilities = false;
            } else {
                this.allFacilities = true;
            }
        }
    },
    mounted: function()
    {
        var self = this;

        var preselectedCategory = self.$el.getAttribute('data-preselected-category');
        if (preselectedCategory) {
            self.categoryFilters.push(preselectedCategory);
        }

        self.$http.get('/api/Venues/GetAllVenues')
        .then(response => {
            self.venueItems = response.data;
            //console.log(self.venueItems);
            var allCapacities = [];
            var filteredCapacities = [];
            self.venueItems.forEach(venueItem => {
                if (venueItem.location && self.locations.indexOf(venueItem.location) === -1) {
                    self.locations.push(venueItem.location);
                }

                venueItem.categories.forEach(function (category) {
                    if (category && self.categories.indexOf(category) === -1) {
                        self.categories.push(category);
                    }
                });

                if (venueItem.capacity && self.capacities.indexOf(venueItem.capacity) === -1) {

                
                    venueItem.capacity.forEach(x => {
                        allCapacities.push(x);
                    });


                    self.capacities.forEach(item => {
                        if (!filteredCapacities.has(item)) {
                            filteredCapacities.push(item);
                        }
                    })

                
                }

                venueItem.facilities.forEach(function (facility) {
                    if (facility && self.facilities.indexOf(facility) === -1) {
                        self.facilities.push(facility);
                    }
                });

                if (venueItem.mainImage === null) {
                    venueItem.mainImage = "/Image/icons/icon-news.svg?width=694&height=316&mode=crop";
                }

                venueItem.keywords = [
                    venueItem.heading,
                    venueItem.textContent
                ].join().toLowerCase();

                self.$nextTick(() => {
                    self.stickyFilters = self.$refs.filterList.offsetTop + self.$refs.filterList.offsetHeight;
                    self.bottomOfList = self.stickyFilters + self.$refs.venuesList.offsetHeight;

                    self.$refs.filterList.isScrolled = false;
                    self.$refs.filterList.style.willChange = "background";
                    window.addEventListener('scroll', self.handleScroll);
                    window.addEventListener('click', self.handleClick);
                })
            });
            var unique = allCapacities.filter((value, index, array) => array.indexOf(value) === index);

            self.capacities = unique.sort((a, b) => {
                a = self.convertCapacityToNumber(a);
                b = self.convertCapacityToNumber(b)
                return a - b
            });


            

            self.categories = self.categories.sort().reverse();

        })
        if (self.$refs.categoryDropdownArea) {
            self.$refs.categoryDropdownArea.addEventListener("mouseleave", self.hoverOutTimeout);
        }
        self.$refs.locationDropdownArea.addEventListener("mouseleave", self.hoverOutTimeout);
        self.$refs.capacityDropdownArea.addEventListener("mouseleave", self.hoverOutTimeout);

        self.headerEl = document.querySelector('#header');
    },
    destroyed () {
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('click', this.handleClick);
    }
});

